"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionBus = void 0;
class ActionBus {
    constructor() {
        this.actionHandlers = {};
    }
    on(action, handler) {
        var _a;
        if (!this.actionHandlers[action]) {
            this.actionHandlers[action] = [];
        }
        (_a = this.actionHandlers[action]) === null || _a === void 0 ? void 0 : _a.push(handler);
    }
    emit(action, ...payload) {
        const handlers = this.actionHandlers[action];
        if (handlers) {
            handlers.forEach((handler) => handler(payload[0]));
        }
    }
    off(action, handler) {
        const handlers = this.actionHandlers[action];
        if (handlers) {
            this.actionHandlers[action] = handlers.filter((h) => h !== handler);
        }
    }
}
exports.ActionBus = ActionBus;
